<template>
  <f7-page name="radary" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Radary</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>
      <div class="radar-legenda-wrap">
        <img :src="radarLegendaUrl" class="radar-legenda">
      </div>
      <f7-toolbar bottom v-if="isImagesLoaded">
        <f7-block class="radar-toolbar">
          <f7-row>
            <f7-col width="20">
              <f7-button class="radar-settings" :disabled="!isImagesLoaded" sheet-open=".radary-settings-sheet" icon-f7="slider_horizontal_3"></f7-button>
            </f7-col>
            <f7-col width="20" class="radar-time">
              {{ currentItemTime }}
            </f7-col>
            <f7-col width="40">
              <f7-range
                  class="radar-range"
                  ref="radarRangeSlider"
                  :min="1"
                  :max="this.radarMaxImages"
                  :step="1"
                  :value="this.currentImageIndex"
                  color="blue"
                  :disabled="(!isImagesLoaded || isPlaying)"
                  @range:change="rangeChanged"
              ></f7-range>
            </f7-col>
            <f7-col width="20">
              <f7-button class="radar-play-btn" :disabled="!isImagesLoaded" @click="animPlay()" :icon-f7="playIcon"></f7-button>
            </f7-col>

          </f7-row>
        </f7-block>
      </f7-toolbar>

      <f7-sheet class="radary-settings-sheet">
        <f7-toolbar>
          <div class="left ml-1 font-weight-bold">Nastavenia</div>
          <div class="right">
            <f7-link sheet-close>Zavrieť</f7-link>
          </div>
        </f7-toolbar>
        <!-- Scrollable sheet content -->
        <f7-page-content>
          <f7-list inline-labels no-hairlines-md class="no-margin-top">
            <f7-list-input
                label="Produkt"
                type="select"
                :value="radarType"
                @change="onChangeRadarType($event)"
            >
              <option v-for="(item, index) in radarDataFiltered" :key="item.product" :value="item.product" :title="item.product_desc">{{ item.product_name }}</option>
            </f7-list-input>
            <f7-list-input
                label="Počet snímok"
                type="select"
                :value="radarNumImages"
                @change="onChangeRadarNumImages($event)"
            >
              <option v-for="(item, index) in listNumImages" :value="item">{{ item }}</option>
            </f7-list-input>
            <f7-list-input
                label="Interval"
                type="select"
                :value="radarInterval"
                @change="onChangeRadarInterval($event)"
            >
              <option v-for="(item, index) in listInterval" :value="item.value">{{ item.text }}</option>
            </f7-list-input>

            <f7-list-input
                :input="false"
                label="Rýchlosť"
            >
              <f7-range slot="input"
                        @range:change="onChangeRadarAnimSpeed($event)"
                        :value="this.radarAnimSpeed" :min="3" :max="10" :step="1"></f7-range>
            </f7-list-input>
            <f7-list-input
                :input="false"
                label="Priehľadnosť"
            >
              <f7-range slot="input"
                        @range:change="onChangeRadarOpacity($event)"
                        :value="this.radarOpacity" :min="10" :max="100" :step="1"></f7-range>
            </f7-list-input>
            <f7-list-item title="Blesky" class="radary-lightning-item">
              <f7-toggle slot="after"
                         :checked="this.radarShowLightning"
                         @change="onChangeRadarLightning($event)"
              ></f7-toggle>
            </f7-list-item>
          </f7-list>

        </f7-page-content>
      </f7-sheet>

      <l-map :zoom="zoom"
             :center="center"
             :options="mapOptions"
             ref="map"
      >
        <l-control-zoom position="bottomright"  ></l-control-zoom>
        <l-tile-layer
            ref="layerBg"
            :url="url"
            :attribution="attribution"
        />
        <l-tile-layer :url="borderUrl" />
        <l-image-overlay
            ref="layerImg"
            :url="imageUrl"
            :bounds="[[50.7, 23.79] , [46.05, 13.6]]"
            :opacity="this.radarOpacity/100"
            className="crispy_image"
            :z-index="1"
        />
        <l-image-overlay
            :visible="radarShowLightning"
            ref="layerImgLightning"
            :url="imageUrlLightning"
            :bounds="[[49.9, 22.9962] , [47.3, 16.0038]]"
            className="crispy_image"
            :z-index="2"
        />

        <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
          <div class="leaflet-bar">
            <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
          </div>
        </l-control>

        <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
          <div class="leaflet-bar">
            <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
          </div>
        </l-control>
        
      </l-map>

    </template>
    <image-preloader
        :srcs="imagesToPreload"
        @loaded-all="imageLoadedAll"
        @loaded="imageLoadedOne"
        @onerror="imagePreloadError"
    />
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import imagePreloader from '../components/imagePreloader'
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";


var progressDialog, loadingDialog;

export default {
  components: {
    'image-preloader': imagePreloader,
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      radarData: [],
      listNumImages: [4, 12, 24],
      listInterval: [
        {value: 5, text: '5 min.'},
        {value: 10, text: '10 min.'},
        {value: 15, text: '15 min.'},
        {value: 30, text: '30 min.'},
        {value: 60, text: '1 hod.'}
      ],
      isDataLoaded: false,
      isImagesLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      playIcon: 'play_fill',
      isPlaying: false,
      currentItemTime: '00:00',
      imagesToWalk: [],
      imagesToWalkLightning: [],
      preloaderLoaded: 0,
      currentImageIndex: 1,
      imageUrl: 'static/shmu/img/blank.png',
      imageUrlLightning: 'static/shmu/img/blank.png',
      radarLegendaUrl: 'static/shmu/img/blank.png',
      base_url: '',
      base_url_lightning: '',
      animTimer: null,
      stopTimer: null,
      radarType: 'data.cmax',
      radarNumImages: 4,
      radarMaxImages: 4,
      radarInterval: 5,
      radarAnimSpeed: 9,
      radarOpacity: 90,
      radarShowLightning: true,

      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  watch: {
    isPlaying: function (val) {
      if (val === true) {
        this.playIcon = 'pause_fill';
      } else {
        this.playIcon = 'play_fill';
      }
    },
    radarAnimSpeed(val) {
      if (this.isPlaying) {
        this.animPlay(); // zastavime
        this.animPlay(); // spustime
      }
    },
    imagesToWalk(val) {
      this.radarMaxImages = val.length;
    },
    radarType(val) {
      this.radarLegendaUrl = SHMUconf.SHMU_CORE_URL + 'img/radary/'+ val +'.png';
    }
  },
  computed: {
    coreUrl() {
      return SHMUconf.SHMU_CORE_URL; // .replace(/\/$/, "");
    },
    radarDataFiltered() {
      return this.radarData.filter((item) => item.product !== 'data.lightning');
    },
    animSpeed() {
      return (11 - this.radarAnimSpeed) * 100;
    },
    imagesToPreload() {
      let finalToLoad = [];

      if (this.radarData.length > 0) {
        let obj = this.radarData.find((item) => item.product === this.radarType);

        let lightning_obj = {};
        if (this.radarShowLightning) {
          lightning_obj = this.radarData.find((item) => item.product === 'data.lightning');
          this.base_url_lightning = lightning_obj.base_url;
        }

        if (obj && obj.items.length > 0) {
          this.base_url = obj.base_url;

          let tmp = obj.items.sort((a, b) => (a.dt < b.dt) ? 1 : -1);
          let first_dt = tmp[0].dt;
          let tmp3 = [];
          let tmp4 = [];
          if (this.radarInterval > 5) {
            let to_max = first_dt - (this.radarNumImages * this.radarInterval * 60);
            for (let z = first_dt; z > to_max; z = z - (this.radarInterval * 60)) {
              let obj_w = tmp.find((item) => item.dt === z);
              if (obj_w) {
                tmp3.push(obj_w);
              }

              if (lightning_obj && lightning_obj.items && lightning_obj.items.length > 0) {
                let obj_t = lightning_obj.items.find((item) => item.dt === z);
                if (obj_t) {
                  tmp4.push(obj_t);
                }
              }
            }
            this.imagesToWalkLightning = tmp4;
          } else {

            tmp3 = tmp.slice(0, this.radarNumImages);
            if (lightning_obj && lightning_obj.items && lightning_obj.items.length > 0) {

              tmp3.forEach(function (v,i) {
                let obj_t = lightning_obj.items.find((item) => item.dt === v.dt);
                if (obj_t) {
                  tmp4.push(obj_t);
                }
              });

              this.imagesToWalkLightning = tmp4;
            } else {
              this.imagesToWalkLightning = [];
            }

          }

          this.imagesToWalk = tmp3.sort((a, b) => (a.dt > b.dt) ? 1 : -1);
          this.imagesToWalk.forEach((v) => {
            finalToLoad.push(obj.base_url + v.fname);
          });


          if (this.imagesToWalkLightning.length > 0) {
            this.imagesToWalkLightning.forEach((v) => {
              finalToLoad.push(this.base_url_lightning + v.fname);
            });
          }

          if (finalToLoad.length > 0) {
            progressDialog = this.$f7.dialog.progress('Načítavam snímky...', 0);
          }
        }
        return finalToLoad;
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');
    this.$nextTick(() => {
      this.initMap();
    });

    // nacitanie zapamatanych parametrov
    if (this.$ls.get('radar_type') !== null) {
      this.radarType = this.$ls.get('radar_type');
    }
    this.radarLegendaUrl = SHMUconf.SHMU_CORE_URL + 'img/radary/'+ this.radarType +'.png';

    if (this.$ls.get('radar_num_images') !== null) {
      this.radarNumImages = parseInt(this.$ls.get('radar_num_images'));
    }

    if (this.$ls.get('radar_show_lightning') !== null) {
      this.radarShowLightning = this.$ls.get('radar_show_lightning');
    }

    if (this.$ls.get('radar_opacity') !== null) {
      this.radarOpacity = parseInt(this.$ls.get('radar_opacity'));
    }

    if (this.$ls.get('radar_anim_speed') !== null) {
      this.radarAnimSpeed = parseInt(this.$ls.get('radar_anim_speed'));
    }

    if (this.$ls.get('radar_interval') !== null) {
      this.radarInterval = parseInt(this.$ls.get('radar_interval'));
    }


  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      //  self.$f7.range.get('.radar-range').max = this.imagesToWalk.length;
      if (self.$f7.range.get('.radar-range')) {
        if (this.radarMaxImages != self.$f7.range.get('.radar-range').max) {
          self.$f7.range.get('.radar-range').max = this.radarMaxImages;
        }
      }
    })
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        loadingDialog = self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getradardata', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.radarData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 1000); // overujem kazdu minutu
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať radarové informácie', 'Nastala chyba');
              }

              loadingDialog.close();
              loadingDialog = null;
            }).catch((error) => {
          loadingDialog.close();
          loadingDialog = null;
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    initMap() {
      const self = this;
      //this.$refs.map.mapObject.ANY_LEAFLET_MAP_METHOD();
      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.map.mapObject);

      // console.log('leafLet init done...')

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 3 * 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    imageLoadedOne(e) {
      progressDialog.setProgress(e.progress);
      if (this.radarShowLightning) {
        progressDialog.setText(Math.round(e.count / 2) + ' z ' + e.length / 2);
      } else {
        progressDialog.setText(e.count + ' z ' + e.length);
      }
    },
    imageLoadedAll(e) {
      progressDialog.close();
      progressDialog = null;
      this.isImagesLoaded = true;
      this.setImage(this.radarMaxImages);

      this.$nextTick(() => {
        this.$$('.radar-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.radarRangeClicked);
      });

    },
    imagePreloadError(e) {
      const self = this;
      if (progressDialog !== null) {
        progressDialog.close();
        progressDialog = null;
      }
      this.isImagesLoaded = true;
      this.setImage(this.radarMaxImages);

      this.$nextTick(() => {
        this.$$('.radar-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.radarRangeClicked);
      });

      self.$f7.dialog.alert('Niektoré obrázky sa nepodarilo načítať.', 'Nastala chyba');
      console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
    },
    rangeChanged(val) {
      if (!this.isPlaying) {
        this.setImage(val);
      }
    },
    radarRangeClicked(e) {
      if (this.isPlaying) {
        this.isPlaying = false;
        clearInterval(this.animTimer);
        clearTimeout(this.stopTimer);
      }
    },
    onChangeRadarType(e) {
      this.radarType = e.target.value;
      this.imagesLoaded = false;

      this.$ls.set('radar_type', this.radarType);
    },
    onChangeRadarNumImages(e) {
      this.radarNumImages = parseInt(e.target.value);
      this.$ls.set('radar_num_images', this.radarNumImages);
      //this.$f7.range.get('.radar-range').max = this.radarNumImages;
    },
    onChangeRadarInterval(e) {
      this.radarInterval = parseInt(e.target.value);
      this.$ls.set('radar_interval', this.radarInterval);
    },
    onChangeRadarAnimSpeed(e) {
      this.radarAnimSpeed = e;
      this.$ls.set('radar_anim_speed', parseInt(this.radarAnimSpeed));
    },
    onChangeRadarOpacity(e) {
      this.radarOpacity = parseInt(e);
      this.$ls.set('radar_opacity', this.radarOpacity);
    },
    onChangeRadarLightning(e) {
      this.radarShowLightning = e.target.checked;
      this.$ls.set('radar_show_lightning', this.radarShowLightning);
    },
    setImage(i) {
      if (i >= this.radarMaxImages) {
        i = this.radarMaxImages;
      }
      this.currentImageIndex = i;
      let fname = '';
      let fname_lightning = '';
      let dt;
      this.imagesToWalk.forEach((v, ii) => {
        if (ii + 1 === i) {
          fname = v.fname;
          dt = v.dt;
          if (this.radarShowLightning) {
            let obj_l = this.imagesToWalkLightning.find((item) => item.dt === dt)
            if (obj_l) {
              fname_lightning = obj_l.fname;
            }
          }
          return;
        }
      });
      if (this.radarShowLightning) {
        if (fname_lightning !== '') {
          this.imageUrlLightning = this.base_url_lightning + fname_lightning;
        } else {
          this.imageUrlLightning = 'static/shmu/img/blank.png';
        }
      }
      if (fname !== '') {
        this.imageUrl = this.base_url + fname;
        this.currentItemTime = this.$moment.unix(dt).format('HH:mm');
      }
    },
    anim() {
      this.animTimer = setInterval(() => {
        if (this.currentImageIndex === this.radarMaxImages) {
          clearInterval(this.animTimer);
          this.restartAnimPlay(1);
          // this.setImage(1);
        } else {
          this.setImage(this.currentImageIndex + 1);
        }

      }, this.animSpeed)
    },
    animPlay() {
      if (this.isPlaying) {
        clearInterval(this.animTimer);
        clearTimeout(this.stopTimer);
        this.isPlaying = false;
      } else {
        this.isPlaying = true;
        this.anim();
      }
    },
    restartAnimPlay(index) {
      const self = this;
      this.stopTimer = setTimeout(function(){
        self.setImage(index);
        self.anim();
      }, this.animSpeed * 1.75)
    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      self.$f7.sheet.close();
    },
    onPageBeforeRemove() {
      const self = this;
      // console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      if (self.sheet) self.sheet.destroy();
    },

    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.map.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.map.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.map.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }


  }



}
</script>

<style lang="scss">

.radar-time {
  font-weight: bold;
  font-size:1.1rem;
}

.md {
  .radar-time {
    padding-top:0.4rem;
  }

  .radar-settings {
    padding-top:0.3rem;
    margin-left:0.5rem;
  }

  .radar-play-btn {
    padding-top: 0.3rem;
    padding-left: 0.8rem;
  }

  .radar-range {
    padding-top: 1.1rem;
  }
}
.radar-toolbar {
  max-width:400px;
  width:100%;
  margin: 0px auto;
}
.crispy_image {
  -ms-interpolation-mode: nearest-neighbor; /* IE */
  image-rendering: -webkit-optimize-contrast; /* Old Android, Safari, UC Browser */
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: crisp-edges; /* Safari */
  image-rendering: pixelated; /* Chrome & Opera */

}
.radary-lightning-item {
  .item-title {
    color: var(--f7-label-text-color);
  }
}


/* Landscape phone to landscape tablet */
@media (max-width: 979px) {
  .radar-legenda-wrap {
    z-index: 1000;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
    left: 0;
    img {
      max-width: 100%;
      height:auto;
    }
  }
}

/* Small desktop */
@media (min-width: 980px)  {
  .radar-legenda-wrap {
    z-index: 1000;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
    left: 50%;

    .radar-legenda {
      position:relative;
      left:-50%;
      max-width: 100%;
      height: auto;
      z-index: 1000;
    }
  }
}







</style>
